import axios, { type AxiosResponse } from '@fs/zion-axios'
import { ROOTSTECH_SERVICE as SERVICE } from '../../serviceNames'
import { getLocaleConfig } from '../../helpers/requestConfig'

// DOCS: /service/rootstech/call-for-content/contracts

type ContractBody = {
  sessionId: string
  locale: string
  cisId?: string
}

const BASE = `${SERVICE}/call-for-content/contracts`

export const signSessionContract = async (body: ContractBody): Promise<AxiosResponse> =>
  axios.post(`${BASE}`, body, getLocaleConfig())
